const INVOICE_STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Borrador',
  ISSUED: 'Emitida',
  PARTIAL: 'Parcial',
  PAID: 'Pagada',
  OVERDUE: 'Vencida',
  CANCELLED: 'Anulada',
  PENDING: 'Pendiente',
};

export function getInvoiceStatusLabel(status?: string | null): string {
  if (!status) return '—';
  return INVOICE_STATUS_LABELS[status] || status;
}

export function getInvoiceStatusTone(
  status: string
): 'success' | 'danger' | 'neutral' | 'info' | 'warning' {
  if (status === 'PAID') return 'success';
  if (status === 'OVERDUE') return 'danger';
  if (status === 'CANCELLED') return 'neutral';
  if (status === 'ISSUED') return 'info';
  return 'warning';
}
